import { Utils } from "utils";
import { ThunkType } from "store/types";
import { Hotels, Route } from "services";
import { Iterable, IPlace } from "types";

import { setHotels, setRoute, setRouteResponse } from "./slice";

export const generateRouteThunk =
  (): ThunkType<Promise<void>> => async (dispatch, getStore) => {
    const request = getStore().route.request;

    dispatch(setRoute(undefined));
    dispatch(setRouteResponse(undefined));

    const route = new Route(request);
    const response = await route.getRouteDays();
    const routePlaces = route.routePlacesInstance;

    const groupedPlaces = routePlaces.getLastResponse() ?? [];

    dispatch(setRoute(response));
    dispatch(setRouteResponse({ places: groupedPlaces }));
  };

export const getHotelsThunk =
  (place: Iterable<IPlace>): ThunkType<Promise<void>> =>
  async (dispatch) => {
    const countryCode = place.address_info.country_code;
    const name = place.address_info.city ?? place.title;
    const countryName = Utils.Helpers.getCountryName(countryCode);

    const hotels = new Hotels(countryName, name);
    await hotels.search();

    const list = hotels.list;
    dispatch(setHotels({ [name]: list }));
  };
